import { configureStore } from '@reduxjs/toolkit'
import { authSlice } from '../slices/authSlice'
import { contactAddressSlice } from '../slices/contactAddressSlice'
import { groupSlice } from '../slices/groupSlice'
import { settingSlice } from '../slices/settingSlice'
import { userSlice } from '../slices/userSlice'

export const store = configureStore({
  reducer: {
    contactAddress: contactAddressSlice.reducer,
    auth: authSlice.reducer,
    setting: settingSlice.reducer,
    group: groupSlice.reducer,
    user: userSlice.reducer,
  },
})
